module.exports = __webpack_public_path__ + "img/bonus_symbol_3.93320708.png";